export default __webpack_public_path__ + "static/1-2d6f8aa46dd0804ba4fb2a5f63933c92.jpeg";